import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Conflict, IConflict } from './conflict';

export interface IContactConflictService {
	updateClient(migrationId: string, conflictId: string): Observable<Conflict>;
	updateContact(migrationId: string, conflictId: string): Observable<Conflict>;
}

const CONTACT_CONFLICT_API = '/api/contactconflict';
const PUT_CONFLICT_CLIENTS =
	(migrationId: string, conflictId: string) => `${CONTACT_CONFLICT_API}/v1/client-conflicts/${migrationId}/conflicts/${conflictId}`;
const PUT_CONFLICT_CONTACTS =
	(migrationId: string, conflictId: string) => `${CONTACT_CONFLICT_API}/v1/contact-conflicts/${migrationId}/conflicts/${conflictId}`;

@Injectable({
	providedIn: 'root'
})
export class ContactConflictService implements IContactConflictService {
	constructor(private http: HttpClient) { }

	updateClient(migrationId: string, conflictId: string): Observable<Conflict> {
		let header: HttpHeaders = new HttpHeaders();
		header = header.append('Accept', 'application/json');

		return this.http.put<IConflict>(PUT_CONFLICT_CLIENTS(migrationId, conflictId), null, { headers: header }).pipe(
			map(conflict => new Conflict(conflict)));
	}

	updateContact(migrationId: string, conflictId: string): Observable<Conflict> {
		let header: HttpHeaders = new HttpHeaders();
		header = header.append('Accept', 'application/json');

		return this.http.put<IConflict>(PUT_CONFLICT_CONTACTS(migrationId, conflictId), null, { headers: header }).pipe(
			map(conflict => new Conflict(conflict)));
	}
}
